// src/components/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/api';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await loginUser({ email, password });
            localStorage.setItem('authToken', response.token);
            navigate('/dashboard');
        } catch (error) {
            const errorMessage = error.non_field_errors
                ? error.non_field_errors[0]
                : 'Login failed. Please try again.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-5">
            <div className="row">
                {/* Left Column for Image */}
                <div className="col-md-6 d-none d-none d-md-flex align-items-center justify-content-center">
                    <img
                        src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1749400079/1_b7hyyz.png"
                        style={{
                            width: '800px',   // Adjust this value as needed
                            height: 'auto',   // Keeps aspect ratio
                        }}
                        alt="Login"
                    />
                </div>

                {/* Right Column for Login Form */}
                <div className="col-md-6">
                    <div className="card" style={{ border: 'none' }}>
                        <div className="card-header-a text-center card-header-custom">
                            <h2 className='fw-bold'>Sign in to your Digis account</h2>
                        </div>

                        {/* Divider with text */}
                        <div className="text-center my-3">
                                <div className="d-flex align-items-center justify-content-center">
                                    <hr className="flex-grow-1 border-top border-secondary" />
                                    <span className="mx-3 text-dark" style={{ whiteSpace: 'nowrap' }}>
                                        Sign in with your email
                                    </span>
                                    <hr className="flex-grow-1 border-top border-secondary" />
                                </div>
                            </div>

                        <div className="card-body">
                            {/* Login Form */}
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="email"
                                    className="form-control mb-3"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <input
                                    type="password"
                                    className="form-control mb-3"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <div className="social-login-buttons">
                                    <button
                                        type="submit"
                                        className="btn btn-lg mx-auto d-block w-100 py-3 rounded-button fw-bold"
                                        style={{ backgroundColor: '#f7af3a', color: 'black' }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Logging in...' : 'Sign In'}
                                    </button>
                                </div>
                            </form>

                            {/* Error Message */}
                            {error && <p style={{ color: 'red' }}>{error}</p>}

                            <hr />

                            {/* Links for Forgot Password and Sign Up 
                            <p className="text-center">
                                <a href="https://backend-django-9c363a145383.herokuapp.com/accounts/password/reset/" className="text-dark">
                                    Forgot Password?
                                </a>
                            </p>
                            */}
                            <p className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-link text-dark p-0"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowModal(true);
                                    }}
                                >
                                    Forgot Password?
                                </button>
                            </p>
                            {/*
                            <p className="text-center">
                                Don't have an account?{' '}
                                <a href="/registerdigiscustomer" className="text-dark">
                                    Sign up
                                </a>
                            </p>
                            */}
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title w-100 text-center fw-bold">Need Help?</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <p>Get in touch with your Digis representative for your password.</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-dark"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};



export default Login;